<template>
  <component
    :is="component"
    type="button"
    :to
    :href
    :aria-label="label"
    :title="label"
    :rel="href ? 'noopener noreferrer' : undefined"
    :target="href ? '_blank' : undefined"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
const props = defineProps<{
  label: string;
  to?: string;
  href?: string;
}>();

const component = computed(() => {
  if (props.to) return resolveComponent('NuxtLink');
  if (props.href) return 'a';
  return 'button';
});
</script>
